import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Grid, Typography, Avatar, CircularProgress } from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import MoneyIcon from '@material-ui/icons/Money';
import Alert from '@material-ui/lab/Alert';
import { getQtdVisitasPorMes } from '../../../../../services/DashboardService';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import DateRangeIcon from '@material-ui/icons/DateRange';

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: 20,
    minHeight: 120,
    maxHeight: 120
  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor: theme.palette.info.main,
    height: 56,
    width: 56,
    zIndex: 1,
    marginRight: -50
  },
  icon: {
    height: 32,
    width: 32
  },
  difference: {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center'
  },
  iconDiferencaNegativo: {
    color: theme.palette.error.dark
  },
  valorDiferencaNegativo: {
    color: theme.palette.error.dark,
    marginRight: theme.spacing(1)
  },

  iconDiferencaPositivo: {
    color: theme.palette.success.dark
  },
  valorDiferencaPositivo: {
    color: theme.palette.success.dark,
    marginRight: theme.spacing(1)
  },
  cardContent: {
    zIndex: 1,
    marginTop: -90,
    marginRight: 25,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  gridProgress: {
    display: 'flex',
    justifyContent: 'center'
  }

}));

const VisitasPorMes = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const [qtdVisitasMes, setQtdVisitasMes] = useState();
  const [mostrarProgress, setMostrarProgress] = useState(false);
  const [mostrarAlertaErro, setMostrarAlertaErro] = useState(false);

  useEffect(() => {
    try {
      getDados();

    }
    catch (e) {

    }
  }, []);

  async function getDados() {
    try {
      setMostrarProgress(true);
      let dados = await getQtdVisitasPorMes();
      if (dados.isSuccess) {
        setMostrarProgress(false);
        setQtdVisitasMes(dados.result);
      } else {
        setMostrarProgress(false);
        setMostrarAlertaErro(true);
      }
    } catch (e) {
      setMostrarProgress(false);
      setMostrarAlertaErro(true);
    }
  }

  return (
    <Grid
      container
      style={{
        display:'flex',
        justifyContent: 'center',
        verticalAlign: 'middle'
      }}
    >
      <Grid
        item
        md={12}
        xs={12}
      >
        <Card
          {...rest}
          className={clsx(classes.root, className)}
          elevation={3}
        >
          <CardContent

          >
            {
              mostrarProgress &&
              <Grid
                container
                md={12}
                xs={12}
              >
                <Grid
                  item
                  md={12}
                  xs={12}
                  className={clsx({
                    [classes.gridProgress]: true
                  })}
                >
                  <CircularProgress/>
                </Grid>
              </Grid>
            }
            {
              !mostrarProgress && !mostrarAlertaErro && qtdVisitasMes &&
              <Grid
                  container
                >
                  <Grid
                    item
                    md={12}
                    xs={12}

                  >
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                      variant="body2"
                    >
                      VISITAS NO MÊS
                    </Typography>

                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}

                  >
                    <Typography variant="h3">{qtdVisitasMes.qtdMesAtual}</Typography>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}

                  >
                    <div className={classes.difference}>
                      {
                        qtdVisitasMes.percentualComparacao < 0 &&
                        <ArrowDownwardIcon
                          className={clsx({
                            [classes.iconDiferencaPositivo]: qtdVisitasMes.percentualComparacao >= 0,
                            [classes.iconDiferencaNegativo]: qtdVisitasMes.percentualComparacao < 0
                          })}
                        />
                      }
                      {
                        qtdVisitasMes.percentualComparacao >= 0 &&
                        <ArrowUpwardIcon
                          className={clsx({
                            [classes.iconDiferencaPositivo]: qtdVisitasMes.percentualComparacao >= 0,
                            [classes.iconDiferencaNegativo]: qtdVisitasMes.percentualComparacao < 0
                          })}
                        />
                      }
                      <Typography
                        className={clsx({
                          [classes.valorDiferencaPositivo]: qtdVisitasMes.percentualComparacao >= 0,
                          [classes.valorDiferencaNegativo]: qtdVisitasMes.percentualComparacao < 0
                        })}
                        variant="body2"
                      >
                        {`${(qtdVisitasMes.percentualComparacao ? qtdVisitasMes.percentualComparacao : 0).toFixed(2)}%`}
                      </Typography>
                      <Typography
                        className={classes.caption}
                        variant="caption"
                      >
                        em comparação com o mês passado
                      </Typography>
                    </div>
                  </Grid>

              </Grid>
            }
            {
              mostrarAlertaErro &&
              <Grid
                container
                md={12}
                xs={12}
              >
                <Grid
                  item
                  md={12}
                  xs={12}
                  className={clsx({
                    [classes.gridProgress]: true
                  })}
                >
                  <Alert severity={'warning'} variant={'outlined'} >Falha ao carregar dados</Alert>
                </Grid>
              </Grid>
            }


          </CardContent>
        </Card>
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
        className={clsx({
          [classes.cardContent]: true
        })}
      >
        <Avatar className={classes.avatar}>
          <DateRangeIcon className={classes.icon} />
        </Avatar>
      </Grid>
    </Grid>
  );
};

VisitasPorMes.propTypes = {
  className: PropTypes.string
};

export default VisitasPorMes;
